import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, FeatherIcon } from 'lucide-react';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  return <header className="w-full bg-white border-b luxury-border sticky top-0 z-50 shadow-sm" data-id="element-147">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-148">
        <Link to="/" className="flex items-center group" data-id="element-149">
          <FeatherIcon size={20} className="accent-color group-hover:scale-110 transition-transform" data-id="element-150" />
          <div className="ml-2" data-id="element-151">
            <span className="text-lg font-bold text-gray-900" style={{
            fontFamily: 'var(--font-serif)'
          }} data-id="element-152">
              Muthamia Content Agency
            </span>
          </div>
        </Link>
        {/* Desktop Navigation - Now positioned on the right */}
        <div className="hidden md:flex space-x-12" data-id="element-153">
          <Link to="/" className={`text-gray-700 hover:text-black hover:accent-color transition-colors relative ${isActive('/') ? 'font-medium accent-color' : ''}`} data-id="element-154">
            {isActive('/') && <span className="absolute -bottom-1.5 left-0 w-full h-0.5 accent-bg" data-id="element-155"></span>}
            Home
          </Link>
          <Link to="/portfolio" className={`text-gray-700 hover:text-black hover:accent-color transition-colors relative ${isActive('/portfolio') ? 'font-medium accent-color' : ''}`} data-id="element-156">
            {isActive('/portfolio') && <span className="absolute -bottom-1.5 left-0 w-full h-0.5 accent-bg" data-id="element-157"></span>}
            Portfolio
          </Link>
          <Link to="/blog" className={`text-gray-700 hover:text-black hover:accent-color transition-colors relative ${isActive('/blog') ? 'font-medium accent-color' : ''}`} data-id="element-158">
            {isActive('/blog') && <span className="absolute -bottom-1.5 left-0 w-full h-0.5 accent-bg" data-id="element-159"></span>}
            Blog
          </Link>
        </div>
        {/* Mobile Menu Button */}
        <div className="md:hidden" data-id="element-160">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 text-gray-700" aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-161">
            {isMenuOpen ? <XIcon size={24} data-id="element-162" /> : <MenuIcon size={24} data-id="element-163" />}
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-white py-4 px-4 border-b luxury-border shadow-md" data-id="element-164">
          <div className="flex flex-col space-y-4" data-id="element-165">
            <Link to="/" className={`text-gray-700 hover:text-black px-2 py-1 ${isActive('/') ? 'font-medium accent-color' : ''}`} onClick={() => setIsMenuOpen(false)} data-id="element-166">
              Home
            </Link>
            <Link to="/portfolio" className={`text-gray-700 hover:text-black px-2 py-1 ${isActive('/portfolio') ? 'font-medium accent-color' : ''}`} onClick={() => setIsMenuOpen(false)} data-id="element-167">
              Portfolio
            </Link>
            <Link to="/blog" className={`text-gray-700 hover:text-black px-2 py-1 ${isActive('/blog') ? 'font-medium accent-color' : ''}`} onClick={() => setIsMenuOpen(false)} data-id="element-168">
              Blog
            </Link>
          </div>
        </div>}
    </header>;
}